const text = (value: unknown) => typeof value === 'string' ? value.trim() : '';
export function readSiteDefaults(company?: any) {
  const value=company?.metadata?.seo;
  let image=text(value?.image);
  try { if(image && !['https:','http:'].includes(new URL(image).protocol))image=''; } catch {image='';}
  return {title:text(value?.title),description:text(value?.description),image,siteName:text(value?.site_name)||text(company?.name)};
}
export function readSiteBootstrap(companyId: string | null) {
  if(typeof document==='undefined')return undefined;
  try {
    const data=JSON.parse(document.getElementById('etlyn-blog-bootstrap')?.textContent||'{}');
    return data.companyId===companyId && data.site ? {name:data.site.siteName,metadata:{seo:{...data.site,site_name:data.site.siteName}}}:undefined;
  } catch {return undefined;}
}
